import {
    OBTENER_APPLICATIONS,
    OBTENER_APPLICATION,
    OBTENER_INTEGRATIONS,
    MARCA_ERROR,
    MARCA_OK,
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_APPLICATIONS:
            return {
                ...state,
                applications: action.payload
            }
        case OBTENER_APPLICATION:
            return {
                ...state,
                application: action.payload
            }
        case OBTENER_INTEGRATIONS:
            return {
                ...state,
                integrations: action.payload
            }
        case MARCA_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case MARCA_OK:
            return {
                ...state,
                mensaje: action.payload
            }       
        default:
            return state;
    }
}